/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $ActionTokenStatus = {
  type: 'Enum',
} as const;
